import { Options } from '../../utils/groups'
import { UnitsMap, UnitSystemKeys, UnitSystemsMap } from './types'

// Note: conversion property, describes going from primary
// (property with conversion = 1) to the other. e.g. for distance
// primary is meters and conversion property in yards describes
// how to convert from metres to yards, i.e. yardsVal = metersVal * yards.conversion
export const unitsMap: UnitsMap = {
  distance: {
    meters: {
      name: 'meters',
      abbreviation: 'm',
      conversion: 1
    },
    yards: {
      name: 'yards',
      abbreviation: 'yd',
      conversion: 1.0936132983
    },
    feet: {
      name: 'feet',
      abbreviation: 'ft',
      conversion: 3.280839895
    }
  },
  speed: {
    mps: {
      name: 'm/s',
      abbreviation: 'm/s',
      conversion: 1
    },
    kph: {
      name: 'kph',
      abbreviation: 'kph',
      conversion: 3.6
    },
    mph: {
      name: 'mph',
      abbreviation: 'mph',
      conversion: 2.2369362920544
    }
  },
  time: {
    seconds: {
      name: 'seconds',
      abbreviation: 's',
      conversion: 1
    }
  },
  percentage: {
    percent: {
      name: '%',
      abbreviation: '%',
      conversion: 1
    }
  },
  revs: {
    rps: {
      name: 'revolutions per second',
      abbreviation: 'rps',
      conversion: 1
    },
    rpm: {
      name: 'revolutions per minute',
      abbreviation: 'rpm',
      conversion: 60
    }
  },
  angle: {
    radians: {
      name: 'radians',
      abbreviation: 'rad',
      conversion: 1
    },
    degrees: {
      name: 'degrees',
      abbreviation: 'deg',
      conversion: 180 / Math.PI
    }
  },
  energy: {
    joules: {
      name: 'joules',
      abbreviation: 'J',
      conversion: 1
    },
    kilojoules: {
      name: 'kilojoules',
      abbreviation: 'kJ',
      conversion: 0.001
    }
  },
  workRate: {
    joulesPerSecond: {
      name: 'joules per second',
      abbreviation: 'J/s',
      conversion: 1
    }
  },
  impulse: {
    newtonSeconds: {
      name: 'newton seconds',
      abbreviation: 'N\u00b7s',
      conversion: 1
    }
  }
}

export const unitSystemsMap: UnitSystemsMap = {
  SI: {
    key: 'SI',
    name: 'SI',
    units: {
      distance: unitsMap.distance.meters,
      speed: unitsMap.speed.mps,
      time: unitsMap.time.seconds,
      percentage: unitsMap.percentage.percent,
      revs: unitsMap.revs.rps,
      angle: unitsMap.angle.radians,
      energy: unitsMap.energy.joules,
      workRate: unitsMap.workRate.joulesPerSecond,
      impulse: unitsMap.impulse.newtonSeconds
    }
  },
  American: {
    key: 'American',
    name: 'American',
    units: {
      distance: unitsMap.distance.yards,
      speed: unitsMap.speed.mph,
      time: unitsMap.time.seconds,
      percentage: unitsMap.percentage.percent,
      revs: unitsMap.revs.rpm,
      angle: unitsMap.angle.degrees,
      energy: unitsMap.energy.joules,
      workRate: unitsMap.workRate.joulesPerSecond,
      impulse: unitsMap.impulse.newtonSeconds
    }
  },
  Canadian: {
    key: 'Canadian',
    name: 'Canadian',
    units: {
      distance: unitsMap.distance.yards,
      speed: unitsMap.speed.kph,
      time: unitsMap.time.seconds,
      percentage: unitsMap.percentage.percent,
      revs: unitsMap.revs.rpm,
      angle: unitsMap.angle.degrees,
      energy: unitsMap.energy.joules,
      workRate: unitsMap.workRate.joulesPerSecond,
      impulse: unitsMap.impulse.newtonSeconds
    }
  },
  British: {
    key: 'British',
    name: 'British',
    units: {
      distance: unitsMap.distance.meters,
      speed: unitsMap.speed.mph,
      time: unitsMap.time.seconds,
      percentage: unitsMap.percentage.percent,
      revs: unitsMap.revs.rps,
      angle: unitsMap.angle.degrees,
      energy: unitsMap.energy.kilojoules,
      workRate: unitsMap.workRate.joulesPerSecond,
      impulse: unitsMap.impulse.newtonSeconds
    }
  },
  Metric: {
    key: 'Metric',
    name: 'Metric',
    units: {
      distance: unitsMap.distance.meters,
      speed: unitsMap.speed.kph,
      time: unitsMap.time.seconds,
      percentage: unitsMap.percentage.percent,
      revs: unitsMap.revs.rpm,
      angle: unitsMap.angle.degrees,
      energy: unitsMap.energy.kilojoules,
      workRate: unitsMap.workRate.joulesPerSecond,
      impulse: unitsMap.impulse.newtonSeconds
    }
  }
}

export const unitSystemOptions: Options<UnitSystemKeys | 'Default'> = [
  { name: 'Default', value: 'Default' },
  ...Object.values(unitSystemsMap).map((system) => ({
    name: system.name,
    value: system.key
  }))
]
